module.exports = __webpack_public_path__ + "img/katy-perry.086aca26.jpg";